import React from 'react';

import hipaaCompliantImage from 'assets/images/security/hipaa-compliant.png';
import phiCompliantImage from 'assets/images/security/phi-compliant.png';
import sslEncryptedImage from 'assets/images/security/ssl-encrypted.png';
import { ExperimentName, EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';

import { SecurityLogo, SecurityLogosWrapper } from './SecurityBadgesLogos-styled-components';

export const SecurityBadgesLogos = () => {
  const { isVariant: shouldDisplay } = useExperiment({
    experiment: EXPERIMENTS[ExperimentName.CHECKOUT_SECURITY_MESSAGING],
  });

  if (!shouldDisplay) {
    return null;
  }

  return (
    <SecurityLogosWrapper>
      <SecurityLogo src={hipaaCompliantImage} alt="HIPAA Compliant" />
      <SecurityLogo src={phiCompliantImage} alt="PIPEDA Compliant" />
      <SecurityLogo src={sslEncryptedImage} alt="256-bit SSL Encrypted" />
    </SecurityLogosWrapper>
  );
};
